import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { MessageCircle, Camera, ScanFace, Trash2, ExternalLink, Clock } from 'lucide-react';
import { t } from '../../lib/i18n';

const formatDate = (value, language) => new Date(value).toLocaleDateString(
  language === 'fr' ? 'fr-FR' : 'en-US',
  { month: 'long', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' },
);

const SessionIcon = ({ session }) => {
  if (session.type === 'simulation') return <ScanFace className="w-4 h-4 text-[var(--lux-gold)]" />;
  if (session.has_photo) return <Camera className="w-4 h-4 text-[var(--lux-gold)]" />;
  return <MessageCircle className="w-4 h-4 text-[var(--lux-gold)]" />;
};

export const SessionList = ({ sessions, language, onOpen, onDelete }) => {
  if (!sessions.length) {
    return (
      <Card className="bg-lux-panel/90 border-white/[0.08]" data-testid="history-empty">
        <CardContent className="py-16">
          <div className="text-center">
            <Clock className="w-8 h-8 text-white/10 mx-auto mb-3" />
            <p className="text-white/30 text-sm">{t('noHistory', language)}</p>
          </div>
        </CardContent>
      </Card>
    );
  }
  return (
    <div className="space-y-2" data-testid="chat-history-session-list">
      {sessions.map(session => (
        <div key={session.session_id} className="fade-in">
          <Card className="bg-lux-panel/90 border-white/[0.08] hover:border-white/15 transition-colors duration-200">
            <CardContent className="py-4">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-lux-gold/10 flex-shrink-0"><SessionIcon session={session} /></div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-white truncate">{session.title}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Clock className="w-3 h-3 text-white/20" />
                    <span className="text-xs text-white/30">{formatDate(session.updated_at || session.created_at, language)}</span>
                    {session.language && (
                      <span className="text-[10px] uppercase tracking-wider text-white/20 bg-white/5 px-1.5 py-0.5 rounded">{session.language}</span>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <Button data-testid="chat-history-open-session-button" variant="ghost" size="sm" onClick={() => onOpen(session)} className="text-white/40 hover:text-[var(--lux-gold)] hover:bg-white/5" aria-label={t('openSimulation', language)}>
                    <ExternalLink className="w-4 h-4" />
                  </Button>
                  <Button data-testid="chat-history-delete-session-button" variant="ghost" size="sm" onClick={() => onDelete(session.session_id)} className="text-white/40 hover:text-[var(--lux-danger)] hover:bg-white/5" aria-label={t('deleteSession', language)}>
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      ))}
    </div>
  );
};
